const {useEffect} = require("react");

export const FloatingHelpButton = () => {
    useEffect(() => {
        document.body.classList.add("show-zd");

        return () => {
            document.body.classList.remove("show-zd");
        };
    }, []);

    return null;
};
